import { render, staticRenderFns } from "./RevenueStructure.vue?vue&type=template&id=3131c07a&scoped=true"
import script from "./RevenueStructure.vue?vue&type=script&lang=js"
export * from "./RevenueStructure.vue?vue&type=script&lang=js"
import style0 from "./RevenueStructure.vue?vue&type=style&index=0&id=3131c07a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3131c07a",
  null
  
)

export default component.exports